import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.users.epm-credentials', {
        url: '/:groupId/epm-credentials',
        params: {groupId: null},
        views: {
            '@company.manage-application': 'companyManageApplicationUsersEpmCredentials'
        },
		resolve: {
			groupId,
        },
    });
}

/** @ngInject */
function groupId($stateParams) {
    return $stateParams.groupId;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/users/epm-credentials/epm-credentials.state.js